'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'forklift';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'f47a';
var svgPathData = ['M16 208c0-17.7 14.3-32 32-32l52.9 0 101.7 93.9c1.5 1.4 3.4 2.1 5.4 2.1l160 0 0 73.6c-12-6.1-25.6-9.6-40-9.6-48.6 0-88 39.4-88 88 0 2.7 .1 5.4 .4 8l-64.7 0c.2-2.6 .4-5.3 .4-8 0-48.6-39.4-88-88-88-29.8 0-56.1 14.8-72 37.4L16 208z', 'M464 8c0-4.4-3.6-8-8-8s-8 3.6-8 8l0 464c0 4.4 3.6 8 8 8l104 0c4.4 0 8-3.6 8-8s-3.6-8-8-8l-96 0 0-456zM16 424a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm0-216c0-17.7 14.3-32 32-32l52.9 0 101.7 93.9c1.5 1.4 3.4 2.1 5.4 2.1l160 0 0 73.6c-12-6.1-25.6-9.6-40-9.6-48.6 0-88 39.4-88 88 0 2.7 .1 5.4 .4 8l-64.7 0c.2-2.6 .4-5.3 .4-8 0-48.6-39.4-88-88-88-29.8 0-56.1 14.8-72 37.4L16 208zm347.5 48l-152.3 0-99.1-91.5 0-84.5c0-17.7 14.3-32 32-32l102.5 0c12.5 0 23.8 7.2 29 18.5l88 189.5zM96 160l-48 0c-26.5 0-48 21.5-48 48L0 424c0 48.6 39.4 88 88 88 40.3 0 74.2-27.1 84.7-64l70.6 0c10.4 36.9 44.4 64 84.7 64 48.6 0 88-39.4 88-88 0-27.3-12.5-51.7-32-67.9l0-88.6c0-3.5-.8-6.9-2.2-10.1L290 59.8C282.1 42.8 265.2 32 246.5 32L144 32c-26.5 0-48 21.5-48 48l0 80zM256 424a72 72 0 1 1 144 0 72 72 0 1 1 -144 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faForklift = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;